export const resultType = {
    win: 'win',
    lose: 'lose',
}
